import { useEffect, useRef } from 'react';

const useAdLoader = (dependencies = []) => {
  const hasAttemptedLoadForThisCycleRef = useRef(false);

  useEffect(() => {
    const attemptLoadAllTasks = () => {
      if (window.loadAllTask && typeof window.loadAllTask === 'function') {
        console.log('Calling window.loadAllTask()');
        window.loadAllTask();
        // No longer need to set ref here, outer logic handles it.
      } else {
        console.warn('Ad SDK loadAllTask not found yet. Retrying in 1 second...');
        const timer = setTimeout(attemptLoadAllTasks, 1000);
        return () => clearTimeout(timer);
      }
    };

    const isLoading = dependencies.length > 0 ? dependencies[0] : undefined;
    let cleanupInnerTimer = undefined;

    if (isLoading === false) {
      if (!hasAttemptedLoadForThisCycleRef.current) {
        cleanupInnerTimer = attemptLoadAllTasks();
        hasAttemptedLoadForThisCycleRef.current = true;
      }
    } else if (isLoading === true) {
      hasAttemptedLoadForThisCycleRef.current = false;
    }

    return () => {
      if (typeof cleanupInnerTimer === 'function') {
        cleanupInnerTimer();
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies]);
};

export default useAdLoader; 